import { createSlice } from '@reduxjs/toolkit'

import { ConfigUpdate } from '../../interfaces/Interfaces'
import {
  BranchInterface,
  BusinessInterface,
  UserInterface,
} from '../../interfaces/ServerInterfaces'
import { changeBusiness, initSystem } from '../actions/globals'

interface InitialInterface {
  business: BusinessInterface | null
  user: UserInterface | null
  businessDetails: BusinessInterface | null
  branches: BranchInterface[]
  loading: boolean
}

const initialState: InitialInterface = {
  business: null,
  user: null,
  businessDetails: null,
  branches: [],
  loading: false,
}

const initSlice = createSlice({
  initialState,
  name: 'init',
  reducers: {
    //Business --------------------------------------------------------------------------------------
    setFullBusiness: (state, action) => ({
      ...state,
      business: action.payload,
    }),
    updateBusiness: (state, action) => ({
      ...state,
      business: { ...state.business, ...action.payload },
    }),
    updateSpecificElementBussiness: (state, action) => {
      const new_elements: ConfigUpdate[] = action.payload

      state.business?.configurationsKey?.forEach((item) => {
        new_elements.forEach((new_value) => {
          if (new_value.key === item.key) item.value = new_value.value
        })
      })
    },
    //Business Details --------------------------------------------------------------------------------------
    setFullBusinessDetails: (state, action) => ({
      ...state,
      businessDetails: action.payload,
    }),
    updateBusinessDetails: (state, action) => ({
      ...state,
      businessDetails: { ...state.businessDetails, ...action.payload },
    }),
    updateSpecificElementBusinessDetails: (state, action) => {
      const new_elements: ConfigUpdate[] = action.payload

      state.businessDetails?.configurationsKey?.forEach((item) => {
        new_elements.forEach((new_value) => {
          if (new_value.key === item.key) item.value = new_value.value
        })
      })
    },
    //Users--------------------------------------------------------------------------------------
    setFullUser: (state, action) => ({ ...state, user: action.payload }),
    updateUser: (state, action) => ({
      ...state,
      user: { ...state.user, ...action.payload },
    }),
    //Branches ---------------------------------------------------------------------------------------
    setBranches: (state, action) => ({ ...state, branches: action.payload }),
  },
  extraReducers(builder) {
    builder
      .addCase(initSystem, (state, action) => {
        const user: UserInterface = action.payload.user
        return {
          ...state,
          business: action.payload.business,
          businessDetails: action.payload.businessDetails,
          user,
          branches: action.payload.branches,
        }
      })
      .addCase(changeBusiness.pending, (state) => ({ ...state, loading: true }))
      .addCase(changeBusiness.fulfilled, (state, action) => ({
        ...state,
        loading: false,
        business: action.payload.business,
        businessDetails: action.payload.businessDetails,
      }))
  },
})

export const {
  setBranches,
  setFullBusiness,
  setFullUser,
  updateBusiness,
  setFullBusinessDetails,
  updateBusinessDetails,
  updateUser,
  updateSpecificElementBussiness,
} = initSlice.actions

export default initSlice.reducer
